import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { AuthorizedAppsAccessLayout } from 'pages/settings/pages/developer/pages/authorizedApps/layout/AuthorizedAppsAccessLayout'
import { AuthorizedAppsPageLayout } from 'pages/settings/pages/developer/pages/authorizedApps/layout/AuthorizedAppsPageLayout'
import { AuthorizedAppsPage } from 'pages/settings/pages/developer/pages/authorizedApps/ui/authorizedAppsPage'

export const AuthorizedAppsRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<AuthorizedAppsAccessLayout />}>
        <Route element={<AuthorizedAppsPageLayout />}>
          <Route path={'/'} element={<AuthorizedAppsPage />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
}
